export enum PutRegionTypes {
  FETCH_PUT_REGION_SUCCESS = "FETCH_PUT_REGION_SUCCESS",
  FETCH_PUT_REGION_FAILURE = "FETCH_PUT_REGION_FAILURE",
  FETCH_PUT_REGION_REQUEST = "FETCH_PUT_REGION_REQUEST"
}